import { Box, Heading, Text } from "@chakra-ui/react";
import { t } from "i18next";
import { OrgPublicProfileDto, OrganizationEntryDto } from "../../../../autogen/bff-api";

interface SourcingEventsSectionProps {
  organization?: OrgPublicProfileDto;
  organizationEntry?: OrganizationEntryDto;
}

export const SourcingEventsSection = ({ organization, organizationEntry }: SourcingEventsSectionProps) => {
  const orgData = organization || organizationEntry;

  if (!orgData) throw new Error("No organization data");

  return (
    <Box width="full" pt={6}>
      <Heading size="md" mb={4}>
        {t("Sourcing Events")}
      </Heading>
      <Text>
        {t("This section will display sourcing events related to")} {orgData.name}.
      </Text>
    </Box>
  );
};
